import React from "react";

const ActionDropdown = ({
   setCustomerType,setTitle,setShow 
  }) => {
  return (
    <div className="dropdown">
      <button
        type="button"
        className="btn btn-sm btn-primary"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="svg-stroke"
        >
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M12 5l0 14" />
          <path d="M5 12l14 0" />
        </svg>
      </button>

      <ul className="dropdown-menu dropdown-menu-end">
        <li>
          <button
            className="dropdown-item"
            type="button"
            onClick={() => {
              setCustomerType("existing");
              setTitle("Select Existing Customer");
              setShow(true);
            }}
          >
            Existing Customer
          </button>
        </li>

        <li>
          <button
            className="dropdown-item"
            type="button"
            onClick={() =>{
              setCustomerType("new");
              setTitle("Add New Customer");
              setShow(true);
            }}
          >
            New Customer
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ActionDropdown;
